import React, { useState } from 'react'
import { ReactComponent as HelpIcon } from '../svgs/help.svg'

interface HelpTooltipProps {
    content: string
    className?: string
}

const HelpTooltip: React.FC<HelpTooltipProps> = ({ content, className = "" }) => {
    const [isVisible, setIsVisible] = useState(false)

    return (
        <div className={`help-tooltip-container ${className}`} style={{ position: 'relative', display: 'inline-block' }}>
            <button
                type="button"
                className="help-tooltip-trigger"
                style={{
                    background: 'none',
                    border: 'none',
                    padding: '2px',
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
                onMouseEnter={() => setIsVisible(true)}
                onMouseLeave={() => setIsVisible(false)}
                onClick={(e) => {
                    e.preventDefault()
                    setIsVisible(!isVisible)
                }}
            >
                <HelpIcon width="16" height="16" />
            </button>
            
            {isVisible && (
                <div 
                    className="help-tooltip-content"
                    style={{
                        position: 'absolute',
                        bottom: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        marginBottom: '8px',
                        padding: '8px 12px',
                        backgroundColor: '#333',
                        color: 'white',
                        borderRadius: '6px',
                        fontSize: '12px',
                        width: '200px',
                        whiteSpace: 'normal',
                        wordWrap: 'break-word',
                        zIndex: 1000,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    }}
                >
                    {content}
                    <div 
                        style={{
                            position: 'absolute',
                            top: '100%',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: 0,
                            height: 0,
                            borderLeft: '6px solid transparent',
                            borderRight: '6px solid transparent',
                            borderTop: '6px solid #333'
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default HelpTooltip